import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {
  Box,
  Grid,
  Container,
  Typography,
  Paper,
  Modal,
  FormControl,
} from '@mui/material';
import { Input } from '../Input';
import { Select } from '../Select';
import { Button as Button2 } from '../Button';
import toast from 'react-hot-toast';
import QrCodeDownload from '../../utils/GerarQrcode';

const CarteirinhaDigital = ({
  empresas,
  handleFormSubmit,
  handleCnpjChange,
  cnpj,
}) => {
  const [open, setOpen] = useState(false);
  const [selectedEmpresa, setSelectedEmpresa] = useState(null);
  const [planos, setPlanos] = useState([]);
  const [link, setLink] = useState('');
  const [plano, setPlano] = useState('');
  const [competencia, setCompetencia] = useState(0);
  const location = window.location.href;
  const UrlBaseLocal = location.replace('/generate/Bussiness-Link', '');

  const Competencia = [
    { Id: 1, Sigla: 'Pré' },
    { Id: 2, Sigla: 'Pós' },
  ];

  const gerarLink = async () => {
    if (!selectedEmpresa) {
      toast.error('Selecione uma empresa!');
      return;
    }
    if (plano === '') {
      toast.error('Selecione um plano antes de gerar o link!');
      return;
    }

    const toastId = toast.loading('Gerando link...');
    try {
      const url = process.env.REACT_APP_OG_API_URL;
      const rtn = await axios.get(
        `${url}/generate/Token?id_empresa=${selectedEmpresa.Id}&id_plano=${plano}`,
      );

      toast.dismiss(toastId);

      if (rtn.status !== 200 || !rtn.data.token) {
        toast.error('Erro ao gerar token. Verifique com o suporte!');
        return;
      }

      setLink(rtn.data.token);
      toast.success('Link gerado com sucesso!');
    } catch (error) {
      toast.dismiss(toastId);
      toast.error('Erro inesperado ao gerar link.');
      console.error(error);
    }
  };

  const handleOpen = async empresa => {
    setSelectedEmpresa(empresa);
    setOpen(true);
    toast.success(`Empresa selecionada: ${empresa.NomeFantazia}`);
    await handleBuscaPlanos(empresa.Id);
  };

  const handlePlanoChange = e => {
    setLink('');
    setPlano(e.target.value);
  };

  const handleCompetenciaChange = e => {
    setLink('');
    setCompetencia(Number(e.target.value));
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedEmpresa(null);
    setPlanos([]);
  };

  const handleBuscaPlanos = async id => {
    try {
      const urlBase = process.env.REACT_APP_URL_BASE;
      const token = process.env.REACT_APP_TOKEN_S4E_V2;
      const response = await axios.get(
        `${urlBase}/api/plano/planos?token=${token}&empresaId=${id}`,
      );
      const Data = response.data.dados;
      if (Data.length > 0) {
        setPlanos(Data);
        toast.success(`${Data.length} plano(s) carregado(s)!`);
      } else {
        toast.error('Nenhum plano encontrado para essa empresa.');
      }
    } catch (error) {
      console.error('Erro ao buscar carteirinha:', error);
      toast.error('Erro ao buscar planos da empresa.');
    }
  };

  const resetInterface = (): void => {
    toast.loading('Redirecionando para nova geração...');

    setTimeout(() => {
      toast.dismiss();
      setOpen(false);
      setSelectedEmpresa(null);
      setPlanos([]);
      setLink('');
      setPlano('');
      setCompetencia(0);
    }, 1200);
  };

  return (
    <Container>
      <form id="form" onSubmit={handleFormSubmit}>
        <div className="flex w-full min-[748px]:grid-cols-2 grid-cols- gap-6 items-end">
          <Input
            label=""
            placeholder="CNPJ da empresa"
            activateMask
            mask="99.999.999/9999-99"
            value={cnpj}
            onChange={handleCnpjChange}
          />
          <Button2 text="Enviar" type="submit" />
        </div>
      </form>

      {empresas.length > 0 && (
        <Box mt={4}>
          <table width="100%">
            <thead style={{ background: '#272D65', color: '#FFFFFF' }}>
              <tr>
                <th style={{ textAlign: 'center' }}>ID Empresa</th>
                <th style={{ textAlign: 'center' }}>Nome Fantasia</th>
              </tr>
            </thead>
            <tbody>
              {empresas.map((empresa, index) => (
                <tr
                  key={index}
                  onClick={() => handleOpen(empresa)}
                  style={{ cursor: 'pointer' }}
                >
                  <td style={{ textAlign: 'center' }}>{empresa.Id}</td>
                  <td style={{ textAlign: 'center' }}>
                    {empresa.NomeFantazia}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {planos.length === 0 && (
            <p style={{ color: '#FF0000', fontSize: '12px' }}>
              * Clique na linha da empresa para gerar o link de inclusão de
              funcionários
            </p>
          )}
        </Box>
      )}

      <Modal open={open} onClose={handleClose}>
        <div
          style={{
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            position: 'absolute',
            backgroundColor: 'white',
            padding: '20px',
            boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
            borderRadius: '10px',
            minWidth: '85%',
            height: '80%',
          }}
        >
          {selectedEmpresa && planos ? (
            <Box>
              <Typography variant="h6">Resumo da Empresa</Typography>
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  <Typography variant="caption">Razão Social:</Typography>
                  <Typography>{selectedEmpresa.RazaoSocial}</Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Typography variant="caption">Nome Fantasia:</Typography>
                  <Typography>{selectedEmpresa.NomeFantazia}</Typography>
                </Grid>
                <Grid item xs={12} md={4}>
                  <Typography variant="caption">CNPJ:</Typography>
                  <Typography>{selectedEmpresa.CNPJ}</Typography>
                </Grid>
                <Grid item xs={12} md={4}>
                  <FormControl fullWidth>
                    <Select
                      label="Plano:"
                      options={[]}
                      optionsFull={planos}
                      placeholder="Plano"
                      value={plano}
                      onChange={handlePlanoChange}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={4}>
                  <FormControl fullWidth>
                    <Select
                      label="Competência"
                      options={[]}
                      optionsFull={Competencia}
                      placeholder="Competência"
                      value={competencia}
                      onChange={handleCompetenciaChange}
                    />
                  </FormControl>
                </Grid>
                {!link ? (
                  <Grid item xs={12}>
                    <Button2 text="Gerar Link" onClick={gerarLink} />
                  </Grid>
                ) : (
                  <Grid container spacing={2} m={2} justifyContent={'center'}>
                    <Box
                      display="flex"
                      flexDirection="row"
                      alignItems="center"
                      width="100%"
                    >
                      <Grid
                        item
                        xs={12}
                        md={8}
                        display={'flex'}
                        flexDirection="row"
                      >
                        <Typography variant="h5">Link gerado: </Typography>
                        <Typography variant="h6" ml={1}>
                          {UrlBaseLocal}/empresa/incluir-funcionario/{link}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <QrCodeDownload
                          link={`${UrlBaseLocal}/empresa/incluir-funcionario/${link}`}
                        />
                      </Grid>
                    </Box>
                  </Grid>
                )}
              </Grid>
            </Box>
          ) : (
            <Typography variant="h6">Carregando planos...</Typography>
          )}
          <Button2
            text="Fechar"
            onClick={handleClose}
            style={{ position: 'absolute', bottom: '20px', right: '20px' }}
          />
        </div>
      </Modal>

      <Grid container spacing={2} gap={3} mt={4}>
        <div style={{ marginTop: '20px' }}>
          <Button2
            title="Voltar à Página principal"
            text="Sair"
            onClick={() => {
              toast('Saindo da página...');
              window.location.href = '/';
            }}
          />
        </div>
        <div style={{ marginTop: '20px' }}>
          <Button2 text="Gerar novo" onClick={resetInterface} />
        </div>
      </Grid>
    </Container>
  );
};

const GenerateLinkScreen: React.FC = () => {
  const [cnpj, setCnpj] = useState('');
  const [empresas, setEmpresas] = useState([]);

  const handleCnpjChange = e => setCnpj(e.target.value);

  const handleFormSubmit = async e => {
    e.preventDefault();
    setEmpresas([]);

    const urlBase = process.env.REACT_APP_URL_BASE;
    const token = process.env.REACT_APP_TOKEN_S4E_V2;
    const cleanedCnpj = cnpj.replace(/[^\d]+/g, '');

    try {
      if (cleanedCnpj.length < 14) {
        toast.error('CNPJ deve conter 14 caracteres!');
        return;
      }

      const retorno = await axios.get(
        `${urlBase}/api/empresa/BuscaEmpresas?token=${token}&cnpj=${cleanedCnpj}`,
      );
      if (retorno.status !== 200) {
        toast.error('Erro na consulta!');
        return;
      }

      const empresasAtivas = retorno.data.dados.filter(
        x => x.CodigoSituacao === 1,
      );
      if (empresasAtivas.length < 1) {
        toast.error('Nenhuma empresa ativa encontrada com o CNPJ informado!');
        return;
      }

      setEmpresas(empresasAtivas);
      toast.success(`${empresasAtivas.length} empresa(s) encontrada(s)!`);
    } catch (error) {
      toast.error('Erro ao buscar associado.');
      console.error('Erro ao buscar associado:', error);
    }
  };

  return (
    <Container>
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="50vh"
      >
        <Paper
          elevation={3}
          style={{ padding: '2rem', maxWidth: '800px', width: '100%' }}
        >
          <Typography variant="h5" gutterBottom>
            Gerar aqui o link para inclusão de Funcionários de uma empresa
          </Typography>
          <CarteirinhaDigital
            empresas={empresas}
            handleFormSubmit={handleFormSubmit}
            handleCnpjChange={handleCnpjChange}
            cnpj={cnpj}
          />
        </Paper>
      </Box>
    </Container>
  );
};

export default GenerateLinkScreen;
